import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import useStyles from "./stylesV2"; // styles for depotStep table
import DashboardTable from "../../../../../../../../../components/DashboardTable/DashboardTable";
import {depotTypesTableStructure} from "../../../ProductsSelectionSteps/components/DepotStep/table-data";
import InfoCard from "../../../DynamicStep/components/InfoCard";

const DepotStepV2 = props => {
  const {
    onAnswerChange,
    questions: [
      depotsQuestion
    ],
    dataService
  } = props;

  const tableClasses = useStyles();

  const depotsOptions = React.useMemo(() => {
    const custodian = dataService.getStepAnswer('product-selection-depot', 'custodians', true);
    depotsQuestion.options = _.get(custodian, 'contract_types');

    return depotsQuestion.options || [];
  }, []);

  const onContractChange = (value) => {
    onAnswerChange(depotsQuestion.uid, value);
  };

  React.useEffect(() => {
    if (!!depotsQuestion.answer && !_.find(depotsOptions, o => o.value === depotsQuestion.answer)){
      onContractChange(undefined); // clean answer as it's not in the options
    }
  }, []);

  if(depotsOptions.length === 0){
    return (
      <InfoCard isNewDesign cardType={'warning'}>
        Bitte wählen Sie zuerst eine Depotbank aus. Danach zeigen wir Ihnen die verfügbaren Depotarten an.
      </InfoCard>
    )
  }

  return (
    <Grid container spacing={2}>
      <DashboardTable
        structure={depotTypesTableStructure}
        dataSource={depotsOptions}
        expanded={true}
        tableClasses={tableClasses}
        withFooter={false}
        options={{
          onContractChange: onContractChange,
          selectedContract: depotsQuestion.answer,
          selectedServiceConcept: dataService.serviceConcept,
          banksDataGrouped: dataService.banksDataGrouped
        }}
      />
    </Grid>
  );
};

export default DepotStepV2;
